import { connectFela } from '../../../dependencies';
import Buttons from './Buttons';
import * as styles from './Buttons.styles';

export default connectFela(styles)(Buttons);

export { default as RemoveReport } from './RemoveReport';
export { default as CreatePreset } from './CreatePreset';
export { default as UpdateReport } from './UpdateReport';
